import AppBar from './AppBar';
import AppRouter from './routes/AppRouter';
import ErrorPage from '@components/common/ErrorPage';
import React, {useState} from 'react';
import ScrollContainer from './ScrollContainer';
import Sidebar from './sidebar/Sidebar';
import {Box, Container, styled} from '@mui/material';
import {useAuth} from '@apps-common/auth-react';

const Content = styled(Container)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  flexShrink: 1,
  flex: 0,
  paddingBottom: theme.spacing(2),
  height: '100%',
  minHeight: 500,
}));

const AppLayout = () => {
  const auth = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const errorLoadingUserInformation =
    !auth.user.claims || !auth.user?.claims.role_level;

  return (
    <Box display="flex" flexDirection="column" height="100%" overflow="hidden">
      <AppBar onMenuClick={() => setSidebarOpen(!sidebarOpen)} />

      <Box display="flex" height="100%" overflow="hidden">
        {errorLoadingUserInformation ? (
          <ErrorPage statusMessage="An unforeseen error occurred while fetching your user data." />
        ) : (
          <>
            <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
            <ScrollContainer>
              <Content>
                <AppRouter />
              </Content>
            </ScrollContainer>
          </>
        )}
      </Box>
    </Box>
  );
};

export default AppLayout;
